import { render, staticRenderFns } from "./AcceptPackageIcon.vue?vue&type=template&id=339fa04e"
import script from "./AcceptPackageIcon.vue?vue&type=script&lang=js"
export * from "./AcceptPackageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports